module.exports = "<div *ngIf=\"apiUrl != productionUrl && apiUrl != localUrl\" class=\"test\">\n            AMBIENTE DI TEST\n</div>\n<div *ngIf=\"!isProduction && apiUrl == localUrl\" class=\"test\">\n            AMBIENTE LOCALE\n</div>\n<ng4-loading-spinner [threshold]=\"500\" [timeout]=\"25000\"   [zIndex]=\"999\"> </ng4-loading-spinner>\n<router-outlet ></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main